define('lq/events/actions/documentZip',[
    'underscore', 
    'lq/events/actions/eventAction', 
    'lq'
], function (_, EventAction, lq) {
	'use strict';

	function DocumentZip(eventData, eventArg) {
	    EventAction.call(this, eventData, eventArg);
	    return this;
	}

    EventAction.extend(DocumentZip, EventAction);

    DocumentZip.typeName = 'DocumentZip';

	DocumentZip.prototype.getBatchType = function () {
        return this.eventData.isDownloadOnly ? 
            EventAction.DO_NOT_BATCH 
            : EventAction.COMMAND_BATCH;
    };

	DocumentZip.prototype.execute = function (continuation, eventActionResponse) {
	    if (this.eventData.isDownloadOnly) {
	        var command = {
                actionId: this.piping.actionId,
	            morphId: this.eventData.morphId,
                parameters: JSON.stringify(this.piping.parameters.getNonSystemParameters())
            };
            window.location = this.piping.url.prepare(lq.getTenantUrl('GeneratedContent/DocumentZip'), command);

	        continuation();
	    } else {
            if (eventActionResponse.Download) {
                var file = {
                    url: eventActionResponse.Url,
                    filename: eventActionResponse.Filename
                };
                window.location = this.piping.url.prepare(lq.getTenantUrl('DynamicContent/DownloadFile'), file);
            }

	        continuation();
        }
	};

    DocumentZip.prototype.createEventActionRequest = function () {
        if (this.eventData.isDownloadOnly)
            return undefined;

        return {
            eventActionType: 'DocumentZip',
            morphId: this.eventData.morphId
        };
    };

	return DocumentZip;
});
